export default __webpack_public_path__ + "static/pamela_k-df6750200a2201125575db055ffbcfa3.jpeg";